<template>
  <span
    class="flex min-w-[75px] flex-shrink-0 items-center justify-center whitespace-nowrap border text-center leading-none transition-all"
    :class="[{ 'cursor-pointer': !static }, tagClasses]"
    @click="$emit('click')"
  >
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const styles = {
  colors: {
    blue: {
      base: 'text-blue',
      hover: 'hover:bg-blue hover:text-white',
      active: 'bg-blue !text-white',
    },
    white: {
      base: 'text-white',
      hover: 'hover:text-blue',
      active: '!text-blue',
    },
    gray: {
      base: 'text-slate-lighten4 border-gray-lighten1',
    },
    slate: {
      base: 'text-slate',
    },
  },
  sizes: {
    md: 'min-h-[24px] py-1 px-2 text-xs',
    lg: 'min-h-[28px] py-[5px] px-2.5 text-sm',
  },
  roundings: {
    lg: 'rounded-lg',
    '2xl': 'rounded-2xl',
  },
};

interface Props {
  active?: boolean;
  color?: keyof typeof styles.colors;
  uppercase?: boolean;
  size?: keyof typeof styles.sizes;
  rounded?: keyof typeof styles.roundings;
  sans?: boolean;
  static?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  color: 'blue',
  uppercase: false,
  size: 'lg',
  rounded: '2xl',
  sans: false,
  static: false,
});

defineEmits<{
  (e: 'click'): void;
}>();

const tagClasses = computed(() => {
  const color: { base: string; hover?: string; active?: string } =
    styles.colors[props.color];

  const classes = [
    styles.sizes[props.size],
    styles.roundings[props.rounded],
    color.base,
    props.sans ? 'font-sans' : 'font-segoe',
  ];

  if (!props.static && color.hover) classes.push(color.hover);
  if (props.active && color.active) classes.push(color.active);
  if (props.uppercase) classes.push('uppercase');

  return classes;
});
</script>
